import * as Config from '../../../config';
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Switch, Route, useRouteMatch, useLocation } from "../../../vendor/router-ROUTER_TARGET";
import { connect } from "react-redux";
import './Genres.css';

import List from './List';
import GenreV2 from './GenreV2'; //'./Genre';
import DJedits from './custom/DJedits';
import Empty from './Empty';

import useGetFromApi from '../../../hooks/useGetFromApi';
import usePageScroll from '../../../hooks/usePageScroll';

function ConnectedGenresManager({ hasSideMenu = true, dimension, user, style, storeRoute }) {
  const [response] = useGetFromApi(`genres`, `/v4/catalog/genres/`);
  let { path, url } = useRouteMatch();
  const { width, height } = dimension;
  const { pathname } = useLocation();

  const items = response ? response.items : null;

  const get = (slug, type) => {
    const item = (items) ? items.find(x => x.slug === slug) : null;
    return item ? item[type] : null;
  }

  let { onScroll } = usePageScroll();

  useEffect(() => {
    if (storeRoute && !Config.GENRES_HAS_CUSTOM_EMPTY && path === '/genres' && items && items.length > 0) { 
      storeRoute.goTo(`/genres/${items[0]['slug']}`);
    }
  }, [path, storeRoute, items])
  
  return (
    <div className={`flexRow genres-page`} style={{ height, ...style }} onScroll={onScroll}>
      { hasSideMenu && (
        <div className={`card-container genres`} style={{ height: height - Config.GRID_PAD, display: hasSideMenu ? 'initial' : 'none' }}>
          <List items={items} uri={url} location={pathname} />
        </div>
      ) }
      <div className={`content-container genres ${hasSideMenu ? 'hasSideMenu' : 'noSideMenu'}`} style={{
        width : hasSideMenu ? width - Config.SUB_SIDEBAR + 16 : width,
        height : height - Config.TAB_BAR_GUTTER
      }}>
        <Switch>
          <Route path={`${path}/dj-edits`} >
            <DJedits hasSideMenu={hasSideMenu} id={110} name={'DJ Edits'} />
          </Route>
          <Route path={`${path}/:genreSlug`} render={ props => {
            return (items && get(props.match.params.genreSlug, `id`))
              ? <GenreV2 hasSideMenu={hasSideMenu} id={get(props.match.params.genreSlug, `id`)} name={get(props.match.params.genreSlug, `name`)} 
                  search={get(props.match.params.genreSlug, `search`)} 
                  notsearch={get(props.match.params.genreSlug, `notsearch`)}
                  category={get(props.match.params.genreSlug, `category`)} 
                />
              : null
          }} />
          { (Config.GENRES_HAS_CUSTOM_EMPTY && user && user.genres.length === 0 ) && (
            <Route exact path={`/genres`} >
              <Empty />
            </Route>
          ) }
        </Switch>
      </div>
    </div>
  )
}

ConnectedGenresManager.propTypes = {
  style: PropTypes.object
}

const GenresManager = connect(
  state => ({
    dimension: state.dimension,
    user: state.user,
    storeRoute: state.storeRoute
  })
)(ConnectedGenresManager);

export default GenresManager;
